export default "__VITE_ASSET__3a5129cc__"